import { RouteEnum } from '@/constants/enums/RouteEnum';
import appSchema from '@/middleware/appSchema';
import auth from '@/middleware/auth';
import { base64UrlToNumber } from '@/utils/base64UrlFormat';
import { RouterView, type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router';

/**
 * B2B 會員共享功能路由
 */
export const businessCommon: RouteRecordRaw[] = [
  {
    /**
     * B2B 新版家庭作業
     */
    path: '/homework-business',
    name: RouteEnum.B2bHomework,
    redirect: { name: RouteEnum.B2bHomeworkEntry },
    component: RouterView,
    meta: {
      layout: 'NoLayout',
      middleware: [auth]
    },
    children: [
      {
        /**
         * B2B 新版家庭作業 - 入口頁
         */
        path: '',
        name: RouteEnum.B2bHomeworkEntry,
        component: () => import('@/views/homeworkB2b/index.vue'),
        meta: {
          layout: 'NoLayout',
          middleware: [auth]
        }
      },
      {
        /**
         * B2B 新版家庭作業 - 寫作
         */
        path: 'writing',
        name: RouteEnum.B2bHomeworkWriting,
        component: () => import('@/views/homeworkB2b/B2bWritingWorkView.vue'),
        meta: {
          layout: 'NoLayout',
          middleware: [auth, appSchema]
        }
      },
      {
        /**
         * B2B 新版家庭作業 - 寫作記錄
         */
        path: 'writingLog',
        name: RouteEnum.B2bHomeworkWritingLog,
        component: () => import('@/views/homeworkB2b/B2bWritingWorkView.vue'),
        meta: {
          layout: 'NoLayout',
          middleware: [auth, appSchema]
        }
      },
      {
        /**
         * B2B 新版家庭作業 - 朗讀
         */
        path: 'readAloud',
        name: RouteEnum.B2bHomeworkReadWork,
        component: () => import('@/views/homeworkB2b/B2bReadAloudWorkView.vue'),
        meta: {
          layout: 'NoLayout',
          middleware: [auth, appSchema]
        }
      },
      {
        /**
         * B2B 新版家庭作業 - 情境對話主題列表
         */
        path: 'conversation',
        name: RouteEnum.B2bHomeworkConversation,
        component: () => import('@/views/homeworkB2b/B2bConversationListView.vue'),
        meta: {
          layout: 'NoLayout',
          middleware: [auth, appSchema]
        }
      },
      {
        /**
         * B2B 新版家庭作業 - 情境對話作答
         */
        path: 'conversationWork/:conversationId([A-Za-z0-9_-]{2,})',
        name: RouteEnum.B2bHomeworkConversationWork,
        component: () => import('@/views/homeworkB2b/B2bConversationWorkView.vue'),
        meta: {
          layout: 'NoLayout',
          middleware: [auth, appSchema]
        },
        beforeEnter: (to: RouteLocationNormalized) => {
          const rawParam: string = to.params.conversationId as string;

          try {
            const num: number = base64UrlToNumber(rawParam);
            if (!Number.isInteger(num)) throw new Error(`Invalid conversationId: ${rawParam}`);
          } catch {
            return { name: RouteEnum.Index };
          }
        }
      },
      {
        /**
         * B2B 新版家庭作業 - 情境對話紀錄
         */
        path: 'conversationLog',
        name: RouteEnum.B2bHomeworkConversationLog,
        component: () => import('@/views/homeworkB2b/B2bConversationWorkView.vue'),
        meta: {
          layout: 'NoLayout',
          middleware: [auth, appSchema]
        }
      }
    ]
  }
];
